import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone'
import SelectField from '../Fields/SelectField';
import MediaItem from '../UI/MediaItem';
import Spinner from '../UI/Spinner';
import Modal from "../UI/Modal";
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {
    get as getMedia,
    showUploadModal,
    hideUploadModal,
    post,
    single
} from '../../store/actions/media';
import BtnPrimary from "../UI/BtnPrimary";

class MediaUploadForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
            selectedWorkspace: -1,
        };
    }

    submit(values) {
        const {files, selectedWorkspace} = this.state;

        if (files.length > 0) {
            values = {
                ...values,
                files: files
            };

            if (selectedWorkspace > 0) {
                values = {
                    ...values,
                    workspaceId: selectedWorkspace
                };
            }

            this.setState({files: []});

            return this.props.post(values);
        }
    }

    onDrop(files) {
        this.setState({
            files: files
        });
    }

    selectWorkspace(value) {
        this.setState({
            selectedWorkspace: value
        });
    }

    getWorkspaceName(selectedWorkspace) {
        const {workspace} = this.props;

        for (let x in workspace.items) {
            if (parseInt(workspace.items[x].id, 10) === parseInt(selectedWorkspace, 10)) {
                return workspace.items[x].title;
            }
        }

        return "All Workspaces";
    }

    removeFromUploadList(event, item) {

        let removeFileName = item.name;
        let newFileList = [];
        let currentFileList = this.state.files;
        let x = null;

        for (x in currentFileList) {
            if (removeFileName !== currentFileList[x].name) {
                newFileList.push(currentFileList[x]);
            }
        }

        this.setState({files: newFileList});
    }

    close(event) {
        this.setState({
            files: []
        });

        this.props.hideUploadModal();
    }

    header() {
        if (this.props.media.submiting) {
            return null;
        } else {
            return (
                <div
                    className={classNamesPrefixed({
                        'form-item': true,
                        'form-select': true
                    })}>
                    <Field
                        defaultValue={{
                            id: null,
                            title: "All Workspaces"
                        }}
                        component={SelectField}
                        clearable={true}
                        label="Upload media to workplace"
                        id="workspace"
                        name="workspace"
                        items={this.props.workspace.items}
                        omitCollapsible={true}
                        input={{
                            name: "workspace",
                            value: this.state.selectedWorkspace,
                            onChange: (event) => this.selectWorkspace(event)
                        }}
                    />
                </div>
            )
        }
    }

    footer() {
        if (this.state.files && this.state.files.length > 0) {
            return (
                <div
                    className={classNamesPrefixed({
                        'form-actions': true
                    })}
                >
                    <BtnPrimary
                        buttonType="submit"
                    >{"Upload (" + this.getWorkspaceName(this.state.selectedWorkspace) + ") "}</BtnPrimary>
                </div>
            )
        } else {
            return null;
        }
    }

    render() {
        const {handleSubmit, media} = this.props;
        const submitting = media.submitting;
        const show = media.showMediaUploadModal;

        return (
            <Modal
                showModal={show}
                title="Add media files"
                icon="plus"
                onClose={(event) => this.close(event)}
                modalHeader={this.header()}
            >
                <form
                    className={classNamesPrefixed({
                        'form': true,
                        'media-upload-form': true
                    })}
                    onSubmit={handleSubmit(this.submit.bind(this))}>
                    {!submitting &&
                    <div>
                        {(!this.state.files || this.state.files.length === 0) &&
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-dropzone': true
                            })}
                        >
                            <Dropzone onDrop={this.onDrop.bind(this)}
                                      style={{width: '100%', height: '100%'}}>
                                <p>
                                    Drop media files here<br/>or
                                </p>
                                <div
                                    className={classNamesPrefixed({
                                        'form-actions': true
                                    })}
                                >
                                    <BtnPrimary>Choose files</BtnPrimary>
                                </div>
                            </Dropzone>
                        </div>
                        }
                        {this.state.files && this.state.files.length > 0 &&
                        <div
                            className={classNamesPrefixed({
                                'media-items': true,
                                'upload-media-files': true
                            })}
                        >
                            {this.state.files.map((item) => (
                                <MediaItem
                                    key={item.name}
                                    item={item}
                                    onDelete={(event) => this.removeFromUploadList(event, item)}
                                    deleteEnabled={true}
                                    clickableThumbnail={true}
                                />
                            ))}
                        </div>
                        }
                    </div>
                    }
                    {submitting && media && !media.filesForUpload &&
                    <div
                        className={classNamesPrefixed({'media-uploading-status': true})}>
                        <div style={{
                            margin: '0 auto 30px auto',
                            textAlign: 'center'
                        }}>
                            <Spinner className={'spinner--center'}/>
                        </div>
                        <div style={{margin: '0 auto', textAlign: 'center'}}>
                            Uploading...
                        </div>
                    </div>
                    }
                    {submitting && media && media.filesForUpload &&
                    <div
                        className={classNamesPrefixed({'media-uploading-status': true})}>
                        <div style={{
                            margin: '0 auto 30px auto',
                            textAlign: 'center'
                        }}>
                            <Spinner className={'spinner--center'}/>
                        </div>
                        <div style={{margin: '0 auto', textAlign: 'center'}}>
                            Uploading... {media.filesUploadComplete} from {media.filesForUpload} files
                        </div>
                    </div>
                    }
                    {this.footer()}
                </form>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        formState: state.form.MediaUploadForm,
        workspace: state.workspace,
        media: state.media
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        single: (id) => dispatch(single(id)),
        post: (values) => dispatch(post(values)),
        getMedia: () => dispatch(getMedia()),
        showUploadModal: () => dispatch(showUploadModal()),
        hideUploadModal: () => dispatch(hideUploadModal())
    };
};

MediaUploadForm = reduxForm({
    form: 'MediaUploadForm'
})(MediaUploadForm);

MediaUploadForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaUploadForm);

export default MediaUploadForm;



// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/MediaUploadForm.js